import moment from 'moment';

export const normalizedData = (values: any) => {
  const format = (range: any[]) => {
    return {
      from: {
        value: range,
        include: true,
      },
      to: {
        value: moment(range).add(3, 'M'),
        include: true,
      },
    };
  };

  return {
    ...values,
    ...(Object.hasOwn(values, 'period') && { period: format(values.period) }),
    ...(Object.hasOwn(values, 'unlockingDate') && { unlockingDate: values.unlockingDate.format() }),
  };
};
